<template>
    <div>
        <v-card flat>
            <v-card-title>
                Previous Invoices
                
                <v-spacer></v-spacer>

                <!-- <v-btn depressed color="red" class="white--text" @click="generateAutomatic">Simulate Automatic Invoices</v-btn> -->
                <v-btn depressed color="green" class="white--text" @click="invoiceDialog = true">Create Invoice</v-btn>
            </v-card-title>
            <v-card-subtitle>Download invoices already generated</v-card-subtitle>

            <v-card-text class="mt-4">
                <v-row>
                    <v-col cols="12" lg="12">
                        <v-row>
                            <v-col cols="12" md="4" offset-md="8">
                                <v-text-field v-model="filter" placeholder="Filter" append-icon="mdi-magnify" clearable></v-text-field>
                            </v-col>
                        </v-row>
                        <v-data-table :headers="headers" :items="invoices" :search="filter" :loading="loading">
                            <template v-slot:item.points="{ item }">
                                {{ formatNumber( item.points, 0 ) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn small depressed color="blue-grey darken-3" class="mr-2 white--text" @click="downloadIinvoice(item)">
                                    <v-icon small>mdi-download</v-icon>
                                </v-btn>
                                <v-btn small depressed color="error" @click="openDeleteDialog(item)">
                                    <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>

                    <!-- <v-col cols="12" lg="3">
                        <v-card color="grey lighten-5" flat class="fill-height">
                            <v-card-title>Upcoming Invoices</v-card-title>
                            <v-card-subtitle>Invoices that will be autogenerated in the next 7 days</v-card-subtitle>
                            <v-card-text>
                                <v-list three-line>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Roberto Torres</v-list-item-title>
                                            <v-list-item-subtitle class="caption"><strong>From</strong>: 2020-05-01 <strong>To</strong>: 2020-05-14</v-list-item-subtitle>
                                            <v-list-item-subtitle class="caption"><strong>Will generate</strong>: 2020-05-25</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Calandra Carter</v-list-item-title>
                                            <v-list-item-subtitle class="caption"><strong>From</strong>: 2020-05-01 <strong>To</strong>: 2020-05-14</v-list-item-subtitle>
                                            <v-list-item-subtitle class="caption"><strong>Will generate</strong>: 2020-05-25</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Calandra Carter</v-list-item-title>
                                            <v-list-item-subtitle class="caption"><strong>From</strong>: 2020-05-01 <strong>To</strong>: 2020-05-14</v-list-item-subtitle>
                                            <v-list-item-subtitle class="caption"><strong>Will generate</strong>: 2020-05-25</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Calandra Carter</v-list-item-title>
                                            <v-list-item-subtitle class="caption"><strong>From</strong>: 2020-05-01 <strong>To</strong>: 2020-05-14</v-list-item-subtitle>
                                            <v-list-item-subtitle class="caption"><strong>Will generate</strong>: 2020-05-25</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Calandra Carter</v-list-item-title>
                                            <v-list-item-subtitle class="caption"><strong>From</strong>: 2020-05-01 <strong>To</strong>: 2020-05-14</v-list-item-subtitle>
                                            <v-list-item-subtitle class="caption"><strong>Will generate</strong>: 2020-05-25</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-col> -->
                </v-row>
            </v-card-text>
        </v-card>

        <v-dialog v-model="invoiceDialog" persistent width="500">
            <v-card>
                <v-card-title>Create Invoice</v-card-title>
                <v-card-subtitle>Generate a manual invoice</v-card-subtitle>
                <v-card-text>
                    <v-autocomplete v-model="invoiceCustomer" :items="customers" item-text="fullName" item-value="id" label="Customer" :error-messages="customerError"></v-autocomplete>
                    <v-row>
                        <v-col cols="6">
                            <v-menu ref="fromDateMenu" v-model="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="fromDateFormatted" label="From Date" hint="MM/DD/YYYY" persistent-hint prepend-icon="mdi-calendar" 
                                        @blur="fromDate = parseDate(fromDateFormatted)" v-on="on" :error-messages="fromDateError"></v-text-field>
                                </template>
                                <v-date-picker v-model="fromDate" no-title @input="fromDateMenu = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="6">
                            <v-menu ref="toDateMenu" v-model="toDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="toDateFormatted" label="To Date" hint="MM/DD/YYYY" persistent-hint prepend-icon="mdi-calendar" 
                                        @blur="toDate = parseDate(toDateFormatted)" v-on="on" :error-messages="toDateError"></v-text-field>
                                </template>
                                <v-date-picker v-model="toDate" no-title @input="toDateMenu = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed text @click="closeInvoiceDialog">Cancel</v-btn>
                    <v-btn depressed text color="primary" @click="createInvoice">Create</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" persistent width="500">
            <v-card>
                <v-card-title>Delete Invoice</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this invoice?

                    This cannot be undone.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed text @click="deleteDialog = false">Cancel</v-btn>
                    <v-btn depressed text color="error" @click="deleteInvoice(item)">DELETE</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            headers: [
                { text: 'Invoice #', value: 'id', align: 'left', sortable: true },
                { text: 'Customer', value: 'fullName', align: 'start', sortable: true },
                { text: 'From Date', value: 'fromDate', align: 'start', sortable: true },
                { text: 'To Date', value: 'toDate', align: 'start', sortable: true },
                { text: 'Points Acumulated', value: 'points', align: 'right', sortable: true },
                { text: 'Created On', value: 'createdOn', align: 'start', sortable: true },
                { text: 'Actions', value: 'actions', align: 'start', sortable: true, width: '17%' },
            ], 
            invoices: [],
            filter: '',

            deleteDialog: false,
            selectedInvoice: null,

            invoiceDialog: false,
            invoiceCustomer: null,
            customers: [],
            fromDateMenu: false,
            fromDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            toDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            toDateMenu: false,
            fromDate: new Date().toISOString().substr(0, 10),
            toDate: new Date().toISOString().substr(0, 10),
            
            customerError: '',
            fromDateError: '',
            toDateError: '',

            loading: false,

            token: '',
        }
    },
    watch: {
        fromDate( v ) {
            this.fromDateFormatted = this.formatDate( v );
        },
        toDate( v ) {
            this.toDateFormatted = this.formatDate( v );
        },
    },
    mounted() {
        document.title = this.$route.name;
        this.init();
    },
    methods: {
        init() {
            this.token = localStorage.getItem( 'wipToken' );
            
            this.loading = true;
            this.$http
                .get( '/proc/data.php', {
                    params: {
                        action: 'getInvoices'
                    },
                })
                .then( response => { 
                    this.loading = false;
                    if( response.data.message == 'Unauthorized' ) {
                        this.logout();
                        this.$router.push('/login');
                    }
                    else
                        this.invoices = response.data; 
                });

            this.$http
                .get( '/proc/data.php', {
                    params: {
                        action: 'getCustomerList'
                    },
                })
                .then( response => { 
                    if( response.data.message == 'Unauthorized' ) {
                        this.logout();
                        this.$router.push('/login');
                    }
                    else
                        this.customers = response.data;
                });
        },
        downloadIinvoice( invoice ) {
            this.$http
                .get( '/proc/data.php', {
                    params: {
                        action: 'downloadInvoice',
                        id: invoice.id
                    },
                    responseType: 'blob',
                } )
                .then( response => { 
                    if( response.data.message == 'Unauthorized' ) {
                        this.logout();
                        this.$router.push('/login');
                    }

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Invoice #${invoice.id}.pdf`); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
        },
        openDeleteDialog( invoice ) {
            this.selectedInvoice = invoice;
            this.deleteDialog = true;
        },
        deleteInvoice() {
            this.loading = true;
            this.$http
                .delete( '/proc/data.php', {
                    params: {
                        action: 'deleteInvoice',
                        id: this.selectedInvoice.id
                    },
                })
                .then( response => { 
                    this.loading = false;

                    if( response.data.message == 'Unauthorized' ) {
                        this.logout();
                        this.$router.push('/login');
                    }
                    
                    if( response.data.status === true ) {
                        // remove invoice from list
                        let pos = this.invoices.map(function(e) { return e.id; }).indexOf( this.selectedInvoice.id );
                        this.invoices.splice( pos, 1 );

                        this.selectedInvoice = null;
                        this.deleteDialog = false;
                    }

                    // delete failed, nothing will happen

                });
        },
        isValid() {
            let errorFound = false;
            this.customerError = this.fromDateError = this.toDateError = '';

            if( this.invoiceCustomer == null || this.invoiceCustomer.length == 0 ) {
                this.customerError = 'required';
                errorFound = true;
            }

            if( this.fromDate == undefined || this.fromDate == null || this.fromDate.length == 0 || !moment( this.fromDate ).isValid() ) {
                this.fromDateError = 'must be a valid date';
                errorFound = true;
            }

            if( this.toDate == undefined || this.toDate == null || this.toDate.length == 0 || !moment( this.toDate ).isValid() ) {
                this.toDateError = 'must be a valid date';
                errorFound = true;
            }

            if( moment( this.fromDate ).isAfter( this.toDate ) ) {
                this.fromDateError = 'must be before the TO date';
                errorFound = true;
            }

            return !errorFound;
        },
        createInvoice() {
            if( !this.isValid() )
                return;

            let axiosOptions = {
                url: '/proc/data.php',
                method: 'post',
                data: {
                    customerId: this.invoiceCustomer,
                    fromDate: this.fromDate,
                    toDate: this.toDate
                },
                params: {
                    action: 'createInvoice'
                },
                json: true,
            };

            this.$http( axiosOptions )
                .then( response => {
                    if( response.data.message == 'Unauthorized' ) {
                        this.logout();
                        this.$router.push('/login');
                    }
                        
                    if( response.data.status == true ) {
                        this.closeInvoiceDialog();
                        this.loading = true;
                        this.$http
                        .get( '/proc/data.php', {
                            params: {
                                action: 'getInvoices'
                            }
                        })
                        .then( response => { 
                            this.loading = false;
                            this.invoices = response.data;
                        });
                    }
                });
        },
        closeInvoiceDialog() {
            this.invoiceDialog = false;
            this.invoiceCustomer = null;
            this.fromDate = new Date().toISOString().substr(0, 10);
            this.toDate = new Date().toISOString().substr(0, 10);
        },
        formatDate( date ) {
            if( !date ) return null;

            const [year, month, day] = date.split('-');
            return `${month}/${day}/${year}`
        },
        parseDate ( date ) {
            if( !date ) return null;

            const [month, day, year] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
        generateAutomatic() {
            let axiosOptions = {
                url: '/proc/data.php',
                method: 'post',
                params: {
                    action: 'createAutomaticInvoices'
                },
                json: true,
            };

            this.$http( axiosOptions )
                .then( response => {
                    console.log(response);
                });
        },
        formatNumber(n, c, d, t) {
            c = isNaN(c = Math.abs(c)) ? 2 : c;
            d = d == undefined ? "." : d;
            t = t == undefined ? "," : t;
            var s = parseFloat(n).toFixed(2) < 0 ? "- " : "";
            var i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
            var j = (j = i.length) > 3 ? j % 3 : 0;
            
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
    }
}
</script>

<style scoped>

</style>